import { Component } from '@theme/component';

/**
 * Săgețile caruselului „Ce ne scriu clienții pe WhatsApp” (blocul `perdele-produs-recenzii`).
 * Derularea, tastatura și atingerea sunt native (scroll-snap); aici doar săgețile, care trec de la capăt la început,
 * ca roata de pe Ella (fără clone de carduri, deci fără conținut dublat pentru cititoarele de ecran).
 *
 * @typedef {object} Refs
 * @property {HTMLElement} track
 *
 * @extends {Component<Refs>}
 */
class PerdeleRecenziiComponent extends Component {
  requiredRefs = ['track'];

  /** @param {number} dir - 1 înainte, -1 înapoi */
  scrollByPage(dir) {
    const { track } = this.refs;
    const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
    const pagina = Math.max(track.clientWidth * 0.8, 1);
    const capat = track.scrollWidth - track.clientWidth;
    const pozitie = Math.abs(track.scrollLeft);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = reduce ? 'auto' : 'smooth';

    if (dir > 0 && pozitie >= capat - 2) {
      track.scrollTo({ left: 0, behavior });
    } else if (dir < 0 && pozitie <= 2) {
      track.scrollTo({ left: capat * rtl, behavior });
    } else {
      track.scrollBy({ left: dir * pagina * rtl, behavior });
    }
  }
}

if (!customElements.get('perdele-recenzii-component')) {
  customElements.define('perdele-recenzii-component', PerdeleRecenziiComponent);
}
